
export const directionOptions = [
    {
        key: 'event-id',
        name: 'Event id'
    },
    {
        key: 'direct-link',
        name: 'Direct link'
    },
    {
        key: 'sport',
        name: 'Sport'
    },
    {
        key: 'competition-id',
        name: 'Competition id'
    },
    {
        key: 'next-off-race',
        name: 'Next Off race'
    },
];
